import { render, staticRenderFns } from "./settingWrapTest.vue?vue&type=template&id=769b1a93&"
import script from "./settingWrapTest.vue?vue&type=script&lang=js&"
export * from "./settingWrapTest.vue?vue&type=script&lang=js&"
import style0 from "./settingWrapTest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports